/*
  R9 (2026-08-29) — troca de cor entre PRODUTOS IRMÃOS sem trocar de página.

  O configurador (.r9sw) e o rail de cores apontam para produtos separados; até
  aqui, clicar era navegação completa (rápida e com posição preservada, mas ainda
  uma recarga). Este arquivo intercepta o clique, busca a página do irmão em
  segundo plano e troca SOMENTE as seções que dependem do produto — galeria,
  buy-box, configurador, breadcrumb, ambientes, ficha, FAQ, recomendações —
  atualizando a URL com pushState. O resto da página (header, seções fixas,
  chat, posição de rolagem) fica literalmente parado.

  SEO: zero impacto. O robô não clica — cada cor continua com URL própria
  servida completa pelo Shopify. Isto é só a experiência de quem já está na página.

  Segurança do funil:
    - o checkout Yever (endShopping) vive no theme.liquid, fora das seções trocadas;
    - o rastreamento de CTA é delegação global, também fora;
    - QUALQUER erro cai em navegação normal (location.href) — nunca deixa o
      cliente preso.

  Scripts das seções trocadas: innerHTML/replaceWith não executa <script>, então
  os recriamos na ordem. Os blocos R9 inicializam por elemento (guards data-*),
  então re-executar sobre o DOM novo é o comportamento desejado.

  Voltar/avançar do navegador: depois de uma troca, o back recarrega a URL
  anterior de verdade (estado limpo) — comportamento idêntico ao de uma loja
  tradicional, que é o que o cliente espera do botão voltar.
*/
(function () {
  if (window.__r9SwapInit) return;
  window.__r9SwapInit = true;

  // Alguns scripts inline das seções fazem customElements.define; na re-execução
  // pós-troca isso lançava 'already defined' e derrubava o resto do script.
  // Define idempotente resolve sem tocar no código dos blocos.
  if (!window.__r9DefineIdem) {
    window.__r9DefineIdem = true;
    var defineOriginal = customElements.define.bind(customElements);
    customElements.define = function (nome, classe, opts) {
      if (customElements.get(nome)) return;
      return defineOriginal(nome, classe, opts);
    };
  }

  var GATILHOS = '.r9sw__chip, .r9sw__comfort-chip, .r9-color-rail__track--sib a';
  var SUFIXOS = [
    '__r9_crumbs',
    '__main',
    '__r9_ambientes',
    '__r9_ficha',
    '__r9_faq_produto',
    '__product-recommendations',
    '__areviews',
  ];

  var houveTroca = false;
  var trocando = false;

  // véu sutil enquanto busca (a página não some — só comunica atividade)
  var css = document.createElement('style');
  css.textContent =
    '#MainContent{transition:opacity .22s ease}' +
    'html.r9-swapping #MainContent{opacity:.55;pointer-events:none}' +
    'html.r9-swapping{cursor:progress}' +
    '@media (prefers-reduced-motion: reduce){#MainContent{transition:none}}';
  (document.head || document.documentElement).appendChild(css);

  function reexecutarScripts(raiz) {
    raiz.querySelectorAll('script').forEach(function (velho) {
      var novo = document.createElement('script');
      for (var i = 0; i < velho.attributes.length; i++) {
        novo.setAttribute(velho.attributes[i].name, velho.attributes[i].value);
      }
      novo.textContent = velho.textContent;
      velho.replaceWith(novo);
    });
  }

  function trocar(url) {
    trocando = true;
    document.documentElement.classList.add('r9-swapping');

    var controller = new AbortController();
    var timeout = setTimeout(function () { controller.abort(); }, 15000);
    return fetch(url.href, { signal: controller.signal, headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) {
        if (!r.ok) throw new Error('http ' + r.status);
        return r.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var trocadas = 0;

        SUFIXOS.forEach(function (suf) {
          document.querySelectorAll('.shopify-section[id*="' + suf + '"]').forEach(function (secao) {
            var nova = doc.getElementById(secao.id);
            if (!nova) return;
            secao.replaceWith(nova);
            reexecutarScripts(nova);
            trocadas += 1;
          });
        });

        if (!trocadas) throw new Error('nenhuma secao trocada');
        clearTimeout(timeout);

        history.pushState({ r9swap: 1 }, '', url.href);
        if (doc.title) document.title = doc.title;
        var metadata = 'link[rel="canonical"],meta[name="description"],meta[property^="og:"],meta[name^="twitter:"]';
        document.head.querySelectorAll(metadata).forEach(function (node) { node.remove(); });
        doc.head.querySelectorAll(metadata).forEach(function (node) {
          document.head.appendChild(node.cloneNode(true));
        });
        document.dispatchEvent(new CustomEvent('r9:product-swapped'));
        houveTroca = true;

        // sinal para análise (não é pageview — é interação de configurador)
        try {
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({ event: 'r9_sibling_swap', page_path: url.pathname });
        } catch (e) {}

        document.documentElement.classList.remove('r9-swapping');
        trocando = false;
      })
      .catch(function (err) {
        clearTimeout(timeout);
        document.documentElement.classList.remove('r9-swapping');
        trocando = false;
        throw err;
      });
  }

  document.addEventListener(
    'click',
    function (ev) {
      if (window.Shopify && Shopify.designMode) return;
      if (ev.defaultPrevented) return;
      if (ev.button !== 0 || ev.metaKey || ev.ctrlKey || ev.shiftKey || ev.altKey) return;

      var alvo = ev.target && ev.target.closest && ev.target.closest(GATILHOS);
      if (!alvo) return;
      var href = alvo.getAttribute('href');
      if (!href || href.indexOf('/products/') === -1) return;
      if (alvo.getAttribute('target') === '_blank') return;

      var url;
      try {
        url = new URL(href, location.origin);
      } catch (e) {
        return;
      }
      if (url.origin !== location.origin) return;
      if (url.pathname === location.pathname) return;
      if (trocando) {
        ev.preventDefault();
        return;
      }

      ev.preventDefault();
      trocar(url).catch(function () {
        location.href = url.href;
      });
    },
    true
  );

  // API para outros blocos (ex.: lightbox da seção Ambientes) dispararem a mesma
  // troca suave por código. Devolve a Promise; quem chama decide o que fazer depois.
  window.r9SiblingSwap = function (href) {
    var url;
    try {
      url = new URL(href, location.origin);
    } catch (e) {
      return Promise.reject(e);
    }
    if (url.origin !== location.origin || url.pathname.indexOf('/products/') === -1) {
      return Promise.reject(new Error('url fora do padrao'));
    }
    if (url.pathname === location.pathname) return Promise.resolve('mesmo-produto');
    if (trocando) return Promise.resolve('ocupado');
    return trocar(url);
  };

  // depois de uma troca, voltar/avançar recarrega de verdade a URL do histórico
  window.addEventListener('popstate', function () {
    if (houveTroca) location.reload();
  });
})();

